import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useParams, useNavigate } from "react-router-dom";
import TextEditor from "../../components/TextEditor";
import CategoriesDropdown from "../../components/CategoriesDropdown";

const AdminBlogEditPage = () => {
    const { id } = useParams(); // Get the dynamic blog ID from the URL
    const navigate = useNavigate();
    const [blog, setBlog] = useState(null); // Store blog data
    const [loading, setLoading] = useState(true); // Loading state
    const [error, setError] = useState(null); // Error state
    const [selectedCategory, setSelectedCategory] = useState(null); // Selected category

    // Fetch blog data by ID
    const fetchBlog = async () => {
        const token = localStorage.getItem("admin_token");
        if (!token) {
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/blogs/${id}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.ok) {
                const data = await response.json();
                setBlog(data); // Set the blog data
                setLoading(false);
                setSelectedCategory(data.category_id);
                console.log(data);
                console.log(blog);
            } else {
                setError("Failed to fetch blog");
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
            setError("An error occurred while fetching the blog");
            setLoading(false);
        }
    };

    const saveBlog = async () => {
        const token = localStorage.getItem("admin_token");
        if (!token) {
            return;
        }

        if (!blog.title || !blog.content) {
            alert("Title and content are required!");
            return;
        }

        try {
            blog.category_id = selectedCategory;
            console.log(blog.category_id);
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/blogs/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(blog), // Send updated blog data, including `active`
            });

            if (response.ok) {
                alert("Blog updated successfully");
                window.location.href = "/admin/all-blogs";
            } else {
                const errorData = await response.json();
                alert(`Failed to update blog: ${errorData.detail || "Unknown error"}`);
            }
        } catch (err) {
            console.error(err);
            alert("An error occurred while saving the blog");
        }
    };

    // Handle blog content change
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setBlog((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    // Handle blog deletion
    const deleteBlog = async () => {
        const token = localStorage.getItem("admin_token");
        if (!token) {
            return;
        }

        const confirmDelete = window.confirm("Are you sure you want to delete this blog?");
        if (!confirmDelete) return;

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/blogs/${id}/`, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.ok) {
                navigate("/admin/all-blogs");
                alert("Blog deleted successfully");
            } else {
                const errorData = await response.json();
                alert(`Failed to delete blog: ${errorData.detail || "Unknown error"}`);
            }
        } catch (err) {
            console.error(err);
            alert("An error occurred while deleting the blog");
        }
    };

    // Fetch blog data when component mounts
    useEffect(() => {
        fetchBlog();
    }, []);

    if (loading) return <p>Yükleniyor...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="p-4">
            <Helmet>
                <title>{blog.title} - Legalbul Admin Paneli</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <h2>Edit Blog</h2>
            {blog && (
                <div>
                    <div className="mb-3">
                        <label htmlFor="author" className="form-label">
                            Yazar
                        </label>
                        <input
                            type="text"
                            id="author"
                            name="author"
                            className="form-control"
                            value={blog.author || ""}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="description" className="form-label">
                            Açıklama yazısı (SEO)
                        </label>
                        <input
                            type="text"
                            id="description"
                            name="description"
                            className="form-control"
                            value={blog.description || ""}
                            onChange={handleChange}
                        />
                    </div>
                    <div>
                        <CategoriesDropdown selectedCategory={selectedCategory} setCategory={setSelectedCategory} />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="content" className="form-label">
                            Blogu Düzenle
                        </label>
                        <TextEditor initialContentValue={blog.content || ""} initialTitleValue={blog.title || ""} setOuterContent={(updatedContent) => setBlog((prev) => ({ ...prev, content: updatedContent }))} setOuterTitle={(updatedContent) => setBlog((prev) => ({ ...prev, title: updatedContent }))} />
                    </div>
                    <div className="mb-3 form-check">
                        <input
                            type="checkbox"
                            id="active"
                            name="active"
                            className="form-check-input"
                            checked={blog.active || false} // Checkbox state
                            onChange={handleChange}
                        />
                        <label htmlFor="active" className="form-check-label">
                            Aktif
                        </label>
                    </div>
                    <button onClick={saveBlog} className="btn btn-success">
                        Değişiklikleri Kaydet
                    </button>
                    <button
                        onClick={() => navigate("/admin/all-blogs")}
                        className="btn btn-secondary ms-2"
                    >
                        Tüm Bloglar
                    </button>
                    <button
                        onClick={deleteBlog}
                        className="btn btn-danger ms-2"
                    >
                        Sil
                    </button>
                </div>
            )}
        </div>
    );
};

export default AdminBlogEditPage;
